<div class="col-md-12" style="margin-left: -125px">
    <div class="tab-pane" role="tabpanel" id="formulario33">
        <fieldset id="agregar_formulari33" class="">
            <div class="container" id="center_div">
                <div class="row">
                    <div class="col-md-12">
                        <div id='page1' class="contenedorFormulario print-wrap page1">
                            <div>
                                <span style="float: right; clear: right;">(S.C.I. - 10°) </span> Formulario 5.6
                                <span style="float: right; clear: right;">1/3</span>
                            </div>
                            <h1><strong>SOLICITUD DE COPROPIEDAD INMOBILIARIA<br> LEY 19.537</strong></h1>
                            <br />
                            <br />
                            <div class="row">
                                <div class="col-md-4">
                                    &nbsp;
                                </div>
                                <div class="col-md-4">
                                    <h2 class="infObligatorios">
                                        <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                    <h2 class="infObligatorios"> {{region}} </h2>
                                    <table class="tablaConBorde">
                                        <tr>
                                            <td>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'urbano'" [checked]="propiedad[0].ubicacion == 'URBANO'" />
                                                <label for="tpradio">URBANO</label>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'rural'" [checked]="propiedad[0].ubicacion == 'RURAL'" />
                                                <label for="tpradio">RURAL</label>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-md-4">
                                    <table style="float: right; clear: right; width: 140px;" class="tablaConBorde table">
                                        <tbody>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    N&Uacute;MERO SOLICITUD
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    Fecha de Ingreso
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td class="letraChica">
                                                    * A LLENAR POR LA D.O.M
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                            <br>
                            <div>
                                <div class="tituloSeccion">
                                    <span> 1.- TIPO CONDOMINIO</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table">
                                    <tr class="fondoResaltado">
                                        <td rowspan="2" align="center" style="vertical-align: middle; width: 80%">
                                            CONSTRUCCIONES O PROYECTOS CON CONSTRUCCIONES DESTINADAS A
                                        </td>
                                        <td style="width: 20%">
                                            CONDOMINIO TIPO
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" style="margin-left: 5%" [(ngModel)]="tipo_condominio[0].condominio['A']" />
                                            <span style="padding-left: 20%; padding-right: 25%">A</span>
                                            <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [(ngModel)]="tipo_condominio[0].condominio['B']" />
                                            <span style="padding-left: 14%">B</span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span> 2.- DIRECCI&Oacute;N DE LA PROPIEDAD</span>
                                    <span class="help-block"></span>
                                </div>
                                <table style="width: 100%" border="0" class="tablaConBorde table">
                                    <tr class="fondoResaltado">
                                        <td style="width: 57%" colspan="3">
                                            CALLE O CAMINO
                                        </td>
                                        <td style="width: 24%">
                                            N&Uacute;MERO
                                        </td>
                                        <td style="width: 19%">
                                            ROL SII
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propiedad[0].calle" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propiedad[0].calle_num" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td style="width: 11%">
                                            MANZANA
                                        </td>
                                        <td style="width: 10%">
                                            LOTE
                                        </td>
                                        <td style="width: 61%" colspan="2">
                                            LOTEO O LOCALIDAD
                                        </td>
                                        <td style="width: 18%">
                                            PLANO DE LOTEO N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="manzana" name="manzana" type="text" [(ngModel)]="propiedad[0].manzana" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" name="lote" id="lote" type="text" [(ngModel)]="propiedad[0].lote" />
                                        </td>
                                        <td colspan="2">
                                            <input disabled class="form-control" id="localidad" name="localidad" type="text" [(ngModel)]="propiedad[0].localidad" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="loteo_numero" name="loteo_numero" type="text" [(ngModel)]="propiedad[0].loteo_numero" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>3.- DECLARACION JURADA</span>
                                    <span class="help-block"></span>
                                </div>

                                <table style="width: 100%;" class="tablaConBordeExterno table">
                                    <tr>
                                        <td colspan="7"><input disabled class="form-control" id="nombre" name="nombre" type="text" [(ngModel)]="propietarios[0].nombre" /></td>
                                        <td align="right" colspan="4"><span>C&Eacute;DULA DE</span></td>

                                    </tr>
                                    <tr>
                                        <td align="left"><span>IDENTIDAD Nº</span></td>
                                        <td colspan="5"><input disabled class="form-control" id="rut" name="rut" type="text" [(ngModel)]="propietarios[0].rut" /></td>
                                        <td colspan="5" align="right"><span>DECLARA BAJO SU RESPONSABILIDAD</span></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span> SER</span></td>
                                        <td align="left"><span>PROPIETARIO</span></td>
                                        <td colspan="3" align="center"><span>(O  REPRESENTANTE  LEGAL  DEL  PROPIETARIO)</span> </td>
                                        <td colspan="2"><span>DEL  BIEN  RAIZ</span></td>
                                        <td align="left" colspan="4"><span>UBICADO  EN  CALLE/ </span></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span>/AVENIDA/CAMINO</span></td>
                                        <td align="right" colspan="3"><input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propietarios[0].direccion" /></td>
                                        <td align="left" colspan="3"><span>NUMERO:</span> </td>
                                        <td align="left" colspan="4"><input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propietarios[0].direccion_num" /></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span>ROL DE AVALUO Nº</span></td>
                                        <td align="right" colspan="2"><input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" /></td>
                                        <td align="left"> <span>DE LA COMUNA DE </span></td>
                                        <td align="right" colspan="7"><input disabled class="form-control" id="comuna" name="comuna" [(ngModel)]="propietarios[0].comuna" type="text" /></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" align="left"><span>QUE SE ENCUENTRA INSCRITO A FOJAS</span></td>
                                        <td align="right"><input disabled class="form-control" id="inscripcion" name="inscripcion" type="text" [(ngModel)]="registro_bienes[0].inscrito" /></td>
                                        <td align="center"><span>N°</span></td>
                                        <td align="right" colspan="2"><input disabled class="form-control" id="num_insc" name="num_insc" type="text" [(ngModel)]="registro_bienes[0].numero" /></td>
                                        <td align="center"><span>AÑO</span></td>
                                        <td align="right"><input disabled class="form-control" id="anio_insc" name="anio_insc" type="text" [(ngModel)]="registro_bienes[0].anio" /></td>
                                        <td colspan="3" align="left"><span>DEL REGISTRO</span></td>
                                    </tr>
                                    <tr>
                                        <td align="left">DE PROPIEDAD</td>
                                        <td colspan="2" align="left"> DEL CONSERVADOR</td>
                                        <td align="left"> DE BIENES </td>
                                        <td align="left"> RAÍCES DE</td>
                                        <td align="left" colspan="6"><input disabled class="form-control" id="bienes" name="bienes" type="text" [(ngModel)]="registro_bienes[0].bienes" /></td>

                                    </tr>
                                    <tr>
                                        <td align="left">EN EL CUAL</td>
                                        <td align="left">SE EMPLAZA</td>
                                        <td colspan="2" align="left"><span>EL PROYECTO</span></td>
                                        <td align="left"><span>PARA EL QUE SE</span></td>
                                        <td colspan="6" align="left"><span>PRESENTA ESTA SOLICITUD</span></td>
                                    </tr>
                                </table>
                                <span class="letraChica">En caso de ser m&aacute;s de un propietario adjuntar hoja anexa</span>
                            </div>
                            <div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left">
                                            NOMBRE O RAZ&Oacute;N SOCIAL
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                        <td>
                                            FIRMA DEL PROPIETARIO
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <input disabled class="form-control" readonly id="nombre_prop" name="nombre_prop" type="text" [(ngModel)]="propietarios[0].nombre" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rut_prop" name="rut_prop" type="text" [(ngModel)]="propietarios[0].rut" />
                                        </td>
                                        <td rowspan="7">

                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left">
                                            REPRESENTANTE LEGAL
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><input disabled class="form-control" readonly id="nombre_rep" name="nombre_rep" type="text" [(ngModel)]="propietarios[0].nombre" /></td>
                                        <td><input disabled class="form-control" id="rut_rep" name="rut_rep" type="text" [(ngModel)]="propietarios[0].rut" /></td>
                                    </tr>

                                    <tr class="fondoResaltado">
                                        <td style="width: 25%" align="left">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 25%">
                                            N°
                                        </td>
                                        <td style="width: 25%">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="propietarios[0].direccion" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="propietarios[0].direccion_num" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="propietarios[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado" align="left">
                                        <td>
                                            E-MAIL
                                        </td>
                                        <td>
                                            TEL&Eacute;FONO
                                        </td>
                                        <td>
                                            FAX
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_prop" name="email_prop" type="email" [(ngModel)]="propietarios[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_prop" name="tel_prop" type="text" [(ngModel)]="propietarios[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_prop" name="fax_prop" type="text" [(ngModel)]="propietarios[0].fax" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado tablaConBordeExterno table">
                                        <td colspan="4" align="left">
                                            PERSONERIA DEL REPRESENTANTE LEGAL
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            SE ACREDITA MEDIANTE
                                        </td>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="acredita" name="acredita" type="text" [(ngModel)]="permiso_notariado[0].acreditacion" />
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            DE FECHA
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha_acr" name="fecha_acr" type="text" [(ngModel)]="permiso_notariado[0].fecha" />
                                        </td>
                                        <td>
                                            Y REDUCIDA A ESCRITURA PUBLICA CON FECHA
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha_esc" name="fecha_esc" type="text" [(ngModel)]="permiso_notariado[0].escritura" />
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            ANTE EL NOTARIO SR(A)
                                        </td>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="notario" name="notario" type="text" [(ngModel)]="permiso_notariado[0].notario" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>4- ARQUITECTO</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left"><span>
                                                NOMBRE O RAZON SOCIAL DE LA EMPRESA</span><span class="letraChica">(cuando corresponda)</span>
                                        </td>
                                        <td style="width: 20%">
                                            R.U.T.
                                        </td>
                                        <td style="width: 15%">
                                            FIRMA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="width: 65%">
                                            <input disabled class="form-control" readonly id="nombre_emp" name="nombre_emp" type="text" [(ngModel)]="arquitectos[0].nombre" />
                                        </td>
                                        <td style="width: 20%">
                                            <input disabled class="form-control" id="rut_emp" name="rut_emp" type="text" [(ngModel)]="arquitectos[0].rut" />
                                        </td>
                                        <td rowspan="5" style="width: 15%"></td>

                                    </tr>
                                    <tr class=" fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left">
                                            NOMBRE ARQUITECTO
                                        </td>
                                        <td style="width: 20%">
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="width: 60%"><input disabled class="form-control" readonly id="nombre_arq" name="nombre_arq" type="text" [(ngModel)]="arquitectos[0].nombre" /></td>
                                        <td style="width: 20%"><input disabled class="form-control" id="rut_arq" name="rut_arq" type="text" [(ngModel)]="arquitectos[0].rut" /></td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda" style="width: 30%">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 30%" class="fondoResaltado">
                                            N°
                                        </td>
                                        <td style="width: 20%" class="fondoResaltado">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 30%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="arquitectos[0].direccion" />
                                        </td>
                                        <td style="width: 30%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="arquitectos[0].direccion_num" />
                                        </td>
                                        <td style="width: 20%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="arquitectos[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda" style="width: 30%">
                                            E-MAIL
                                        </td>
                                        <td class="fondoResaltado" style="width: 30%">
                                            TEL&Eacute;FONO
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            FAX
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            PATENTE PROFESIONAL N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_arq" name="email_arq" type="email" [(ngModel)]="arquitectos[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_arq" name="tel_arq" type="text" [(ngModel)]="arquitectos[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_arq" name="fax_arq" type="text" [(ngModel)]="arquitectos[0].fax" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="pat_arq" name="pat_arq" type="text" [(ngModel)]="arquitectos[0].patente" />
                                        </td>
                                    </tr>
                                </table>
                                <span class="letraChica">NOTA: DE HABER MAS DE UN PROFESIONAL RESPONSABLE, ADJUNTAR DOCUMENTO CON FORMATO SIMILAR AL ANTERIOR QUE CONTENGA LOS DATOS NECESARIOS.</span>
                            </div>
                            <div>
                                <br>
                                <div class="tituloSeccion">
                                    <span>5.- REGLAMENTO DE COPROPIEDAD</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="">
                                        <td class="fondoResaltado" colspan="8" align="left">ESCRITURA P&Uacute;BLICA</td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado" align="left" style="width: 10%">NOTAR&Iacute;A:</td>
                                        <td colspan="3" style="width: 50%"><input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="reglamento_copropiedad[0].notaria_reg_copro" /></td>
                                        <td class="fondoResaltado" align="left" style="width: 10%">FECHA:</td>
                                        <td colspan="3" style="width: 30%"><input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="reglamento_copropiedad[0].fecha_notaria" /></td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado" colspan="8">ARCHIVO</td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado" align="left" style="width: 10%">C.B.R. DE:</td>
                                        <td style="width: 20%"><input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="reglamento_copropiedad[0].cbr_reg_copro" /></td>
                                        <td class="fondoResaltado" align="left" style="width: 15%">REGISTRO A&Ntilde;O:</td>
                                        <td style="width: 15%"><input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="reglamento_copropiedad[0].registro_anio" /></td>
                                        <td class="fondoResaltado" align="left" style="width: 10%">FOJAS: </td>
                                        <td style="width: 13%"><input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="reglamento_copropiedad[0].fojas_reg_copro" /></td>
                                        <td class="fondoResaltado" align="left" style="width: 4%">Nº:</td>
                                        <td style="width: 13%"><input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="reglamento_copropiedad[0].numero" /></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div id='page2' class="contenedorFormulario print-wrap page2">
                            <div>
                                <span style="float: right; clear: right;">(S.C.I. - 10°) </span> Formulario 5.6
                                <span style="float: right; clear: right;">2/3</span>
                            </div>
                            <div class="tituloSeccion">
                                <span>6.- ANTECEDENTES QUE SE ADJUNTAN</span>
                            </div>
                            <div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td style="width: 3%">DOM</td>
                                        <td colspan="2">DOCUMENTOS</td>
                                    </tr>
                                    <tr>
                                        <td style="vertical-align: middle" align="center"></td>
                                        <td style="vertical-align: middle; width: 3%" align="center"><input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" checked disabled/></td>
                                        <td style="vertical-align: middle">Listado de Antecedentes y Planos Numerados</td>
                                    </tr>
                                    <tr>
                                        <td style="vertical-align: middle" align="center"></td>
                                        <td style="vertical-align: middle" align="center"><input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" checked disabled/></td>
                                        <td style="vertical-align: middle">Fotocopia del Permiso de Construcción (edificación o urbanización)</td>
                                    </tr>
                                    <tr>
                                        <td style="vertical-align: middle" align="center"></td>
                                        <td style="vertical-align: middle" align="center"><input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" checked disabled/></td>
                                        <td style="vertical-align: middle">Certificado de Recepción de las Obras de Urbanización requeridas por el DOM en el Certificado de Informaciones Previas (en caso de predios afectos a declaratorias de utilidad pública)</td>
                                    </tr>
                                    <tr>
                                        <td style="vertical-align: middle" align="center"></td>
                                        <td style="vertical-align: middle" align="center"><input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" /></td>
                                        <td style="vertical-align: middle">Certificado de Garantía de Obras de Urbanización de Areas Afectas a Utilidad Pública (sólo en los casos en que las obras de edificación no estén recepcionadas)</td>
                                    </tr>
                                    <tr>
                                        <td style="vertical-align: middle" align="center"></td>
                                        <td style="vertical-align: middle" align="center"><input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" /></td>
                                        <td style="vertical-align: middle">Fotocopia de la(s) resolución(es) modificatoria(s) del proyecto, cuando corresponda</td>
                                    </tr>
                                    <tr>
                                        <td style="vertical-align: middle" align="center"></td>
                                        <td style="vertical-align: middle" align="center"><input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" checked disabled/></td>
                                        <td style="vertical-align: middle">Fotocopia del comprobante de archivo en el C.B.R. del Reglamento de Copropiedad</td>
                                    </tr>
                                    <tr>
                                        <td style="vertical-align: middle" align="center"></td>
                                        <td style="vertical-align: middle" align="center"><input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" checked disabled/></td>
                                        <td style="vertical-align: middle">Fotocopia del Formulario F 2803 del SII, Solicitud de Avalúo Fiscal de las Unidades</td>
                                    </tr>
                                    <tr>
                                        <td style="vertical-align: middle" align="center"></td>
                                        <td style="vertical-align: middle" align="center"><input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" checked disabled/></td>
                                        <td style="vertical-align: middle">Fotocopia de la patente al día del arquitecto</td>
                                    </tr>
                                    <tr>
                                        <td style="vertical-align: middle" align="center"></td>
                                        <td style="vertical-align: middle" align="center"><input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" checked disabled/></td>
                                        <td style="vertical-align: middle">Lista de Unidades Vendibles y prorrateo</td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td>DOM</td>
                                        <td colspan="2">PLANOS</td>
                                    </tr>
                                    <tr>
                                        <td style="vertical-align: middle" align="center"></td>
                                        <td style="vertical-align: middle" align="center"><input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" /></td>
                                        <td style="vertical-align: middle">Plantas de todos los pisos identificando las unidades, áreas comunes y sectores, en su caso.</td>
                                    </tr>
                                </table>
                                <table class="tablaConBorde2 table form-group">
                                    <tr>
                                        <td colspan="3">
                                            <span style="margin-left: 3%">-Todos los ejes entre Unidades con línea convencional  <strong>____.____.____.___.____.____ </strong></span><br>
                                            <span style="margin-left: 3%">-Incluir lista de unidades vendibles</span><br>
                                            <span style="margin-left: 3%">-Preferentemente viñeta seg&uacute;n formato municipal (opcional)</span><br>
                                        </td>
                                    </tr>
                                </table>
                                <br>
                                <strong>NOTAS:</strong><br>
                                <span>NO SE REQUIERE CONTAR CON RECEPCIÓN DEFINITIVA </span><br>
                                <span>TODAS LAS FIRMAS EN ORIGINAL</span><br>
                                <span>UNA VEZ AUTORIZADO EL PAGO DE DERECHOS SE DEBE AGREGAR 1 JUEGO DE PLANOS EN POLIESTER</span>
                                <br>
                            </div>
                        </div>
                        <br>
                        <div id='page3' class="contenedorFormulario print-wrap page3">
                            <div>
                                <span style="float: right; clear: right;">(S.C.I. - 10°) </span> Formulario 5.6
                                <span style="float: right; clear: right;">3/3</span>
                            </div>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <div class="col-md-3"></div>
                            <div class="col-md-6" align="center">
                                <h1><strong>COMPROBANTE DE INGRESO</strong></h1>
                            </div>
                            <div class="col-md-3">
                                <span style="float: right; clear: right;">S.G.U. - 129</span>
                            </div>
                            <div class="col-md-12" align="center">
                                <span>SOLICITUD DE COPROPIEDAD INMOBILIARIA</span>
                            </div>
                            <br>
                            <br>
                            <br>
                            <div class="row">
                                <br>
                                <div class="col-md-3">
                                    <table class="tablaConBordeExterno">
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr align="center">
                                            <td>FIRMA FUNCIONARIO.</td>
                                        </tr>
                                        <tr align="center">
                                            <td> Y TIMBRE D.O.M.</td>
                                        </tr>

                                    </table>

                                </div>
                                <br />
                                <div class="col-md-1"></div>
                                <div class="col-md-4">
                                    <h2 class="infObligatorios">
                                        <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                    <h2 class="infObligatorios"> {{region}} </h2>
                                </div>
                                <div class="col-md-4">
                                    <table style="float: right; clear: right; width: 64%;" class="tablaConBorde table">
                                        <tbody>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    N&Uacute;MERO SOLICITUD
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center" class="fondoResaltado" style="width: 20%">
                                                    Fecha de Ingreso
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                            <br />
                            <div>
                                <table class="tablaConBorde">
                                    <tr class="fondoResaltado">
                                        <td style="width: 80%">CALLE O CAMINO</td>
                                        <td>N&Uacute;MERO</td>
                                    </tr>
                                    <tr>
                                        <td><input align="10%" class="form-control" type="text" id="calle" name="calle" disabled [(ngModel)]="propiedad[0].calle" /></td>
                                        <td><input class="form-control" type="text" id="numero" name="numero" disabled [(ngModel)]="propiedad[0].calle_num" /></td>
                                    </tr>
                                </table>
                            </div>
                            <hr />
                            <br />
                            <br />
                            <br />
                            <br />

                            <br />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12" align="left">
                <button mat-raised-button color="primary" id="pdf-download-link" title="Descargar Formulario 5.6" (click)="captureScreen()">Descargar Formulario 5.6</button>
            </div>

        </fieldset>
    </div>
</div>